import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Url = props => {
  var {
    Url: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Url');
  return null;
};
Url.displayName = 'JVR.Url';